import { useMemo } from 'react';
import {
  canAccessAdminPath,
  firstAdminPath,
  visibleAdminNavGroups,
  type AdminNavGroup,
} from '@/shared/config';
import { useAuthStore } from './auth-store';

export interface AdminAccess {
  groups: AdminNavGroup[];
  canAccess: boolean;
  firstPath: string | undefined;
  canAccessPath: (path: string) => boolean;
}

export function useAdminAccess(): AdminAccess {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const permissionsKey = useAuthStore((s) => s.user?.permissions?.join(',') ?? '');
  const rolesKey = useAuthStore((s) => s.user?.roles.join(',') ?? '');

  return useMemo(() => {
    const groups = visibleAdminNavGroups(hasPermission);
    return {
      groups,
      canAccess: groups.length > 0,
      firstPath: firstAdminPath(hasPermission),
      canAccessPath: (path: string) => canAccessAdminPath(hasPermission, path),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ключи прав/ролей и есть зависимость hasPermission
  }, [hasPermission, permissionsKey, rolesKey]);
}
